import * as React from 'react';
import InlineDialog from '@atlaskit/inline-dialog';

interface Props {
  position?:
    | 'auto-start'
    | 'auto'
    | 'auto-end'
    | 'top-start'
    | 'top'
    | 'top-end'
    | 'right-start'
    | 'right'
    | 'right-end'
    | 'bottom-end'
    | 'bottom'
    | 'bottom-start'
    | 'left-end'
    | 'left'
    | 'left-start';
  renderMessage: (dismissMessage: () => void) => React.ReactNode;
  renderTitle: (toggleMessage: () => void) => React.ReactNode;
}

const DismissableInlineMessage = ({ position = 'left-end', renderMessage, renderTitle }: Props) => {
  const [isOpen, setOpen] = React.useState(false);
  const dismissMessage = () => {
    setOpen(false);
  };

  const toggleMessage = () => {
    setOpen(!isOpen);
  };

  return (
    <InlineDialog
      content={renderMessage(dismissMessage)}
      isOpen={isOpen}
      onClose={dismissMessage}
      placement={position}
      testId="dismissable-inline-message"
    >
      {renderTitle(toggleMessage)}
    </InlineDialog>
  );
};

export default DismissableInlineMessage;
